import { getId, Icon, List, Modal, PrimaryButton, Spinner, SpinnerSize } from "@fluentui/react";
import { primaryButtonStyles } from "../../common/views/DefaultStyles";
import { StyleUtils } from "../../common/views/StyleUtils";
import { Utils } from "../../common/views/Utils";
import { PopUpType } from "../../home/models/OtherTypes";
import { UploadPictureModel, FileType, FileCategory } from "../models/PictureModel";
import PictureInputView from "./PictureInputView";

type AddPictureListProps = {
    popupType: PopUpType;
    prefix: string;
    pictures: UploadPictureModel[];
    setPictures: (pictures: UploadPictureModel[]) => void;
    loading: boolean;
    listHash: number;
    setListHash: (value: number) => void;
    onValueChange: <K extends keyof UploadPictureModel>(
        id: number, field: K, value: UploadPictureModel[K]) => void;
    onCreateList: (prefix: string) => void;
    onClose: () => void;
}

export default function AddPictureListView({
    popupType, pictures, setPictures, prefix, loading,
    listHash, setListHash, onValueChange, onCreateList, onClose
}: AddPictureListProps) {
    const titleId: string = getId('title');
    const subtitleId: string = getId('subText');

    const width2 = Utils.getColumnWidth(2);
    const width10 = Utils.getColumnWidth(10);
    const column = Utils.getColumnWidth(2);

    const modelHeader = () => {
        return <div className="ms-Grid">
            <div className="ms-Grid-row">
                <div className={width10}><b>Add Pictures</b></div>
                <div className={width2 + " right"}>
                    <Icon
                        iconName="ChromeClose"
                        className="pointer"
                        onClick={onClose} />
                </div>
            </div>
        </div>;
    }

    const modelView = () => {
        return <>
            <Modal
                titleAriaId={titleId}
                subtitleAriaId={subtitleId}
                isOpen={true}
                onDismiss={onClose}
                isBlocking={true}
                isModeless={false}
                styles={StyleUtils.getModalWidthStyles(800)}
            >
                <div className="popup-header">
                    {modelHeader()}
                </div>
                <div id={subtitleId} className="popup-body">
                    {contentView()}
                </div>
            </Modal>
        </>
    }

    const contentView = () => {
        return <>
            <div className="pv-20 center">
                <input id="uploadFile" name="uploadFile" type="file"
                    onChange={(e) => onLoadFiles(e.target)} multiple />
            </div>

            {loading && <Spinner size={SpinnerSize.large} />}

            <div className="ms-Grid">
                {printHeader()}
                <List items={pictures} onRenderCell={onRenderRow} key={listHash} />
            </div>

            {!loading && <div className="ms-Grid-row center pv-20">
                <PrimaryButton
                    onClick={() => onCreateList(prefix)}
                    styles={primaryButtonStyles}
                    style={{ width: 150 }}
                >Submit</PrimaryButton>
            </div>}
        </>;
    }

    const printHeader = () => {
        return <div className="ms-Grid-row font-bold pv-10">
            <div className={column}></div>
            <div className={column}>Category</div>
            <div className={column}>Type</div>
            <div className={column}>Order</div>
            <div className={column}>Collage Order</div>
            <div className={column}>Is Primary</div>
        </div>
    }

    const onRenderRow = (picture?: UploadPictureModel, index?: number) => {
        if (!picture) { return <></>; }

        return <>
            <PictureInputView
                picture={picture}
                index={index ?? 0}
                onValueChange={onValueChange}
            />
        </>;
    }

    const onLoadFiles = (event: HTMLInputElement) => {
        setPictures([]);

        if (event.files && event.files.length > 0) {
            for (var i = 0; i < event.files.length; i++) {
                loadDisplayPicture(event.files[i], i, event.files.length);
            }
        }
    }

    const loadDisplayPicture = (file: File, index: number, length: number) => {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            let model: UploadPictureModel = {
                type: FileType.image,
                category: FileCategory.normal,
                collageOrder: 99,
                bytes: [reader.result],
                file: file,
                id: 0,
                isPrimary: false,
                order: 0,
                length: 0,
                imageUrl: [reader.result]
            }

            pictures.push(model);

            setPictures(pictures);

            if (index === length - 1) {
                setListHash(Utils.getRandomKey());
                //setLoading(false);
            }
        };
    }

    return <>
        {popupType === PopUpType.none && contentView()}
        {popupType === PopUpType.modal && modelView()}
    </>
}